module.exports = __webpack_public_path__ + "static/media/60-iveco.2cd97549.jpg";